import React from "react";

import { IconProps } from "fe-shared/src/types/common";

const TireIcon = ({
  width = "16",
  height = "16",
  style,
  className,
  fillClassName,
  fillColor = "#000",
}: IconProps) => (
  <svg
    style={style}
    width={width}
    height={height}
    aria-hidden="true"
    viewBox="0 0 16 16"
    className={className}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      fill={fillColor!}
      className={fillClassName}
      d="M1.33 8a6.67 6.67 0 1113.34 0A6.67 6.67 0 011.33 8zM8 12a4 4 0 100-8 4 4 0 000 8z"
    />
  </svg>
);

export default TireIcon;
